import { z } from 'zod';

export const postalSchema = z.object({
  id: z.string(),
  createdTime: z.string(),
  status: z.enum(['未領取', '已領取', '退貨中', '已退貨']),
  plateNumber: z.string(),
  position: z.string(),
  receiver: z.string(),
  type: z.string(),
  isOpenable: z.boolean(),
});

export const postalListSchema = z.array(postalSchema);

export type Postal = z.infer<typeof postalListSchema>[0];
